module.exports = __webpack_public_path__ + "static/img/bg_vca.ad7b792.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bg_vca.png
// module id = 675
// module chunks = 0